export default __webpack_public_path__ + "static/media/Trickster's Charm.ac74a846.jpg";